import {  Image } from "react-bootstrap"
import funder1 from "../images/funders/DeSproelberch.jpg"
import funder2 from "../images/funders/NINDS.png"
import funder3 from "../images/funders/Nomis.jpg"
import funder4 from "../images/funders/BRAIN.png"
import React, { useState } from "react"

export default function Funders() {
  const [isShown, setIsShown] = useState(false)
  const [isShown2, setIsShown2] = useState(false)
  const [isShown3, setIsShown3] = useState(false)
  const [isShown4, setIsShown4] = useState(false)
  return (
    <>
      <div>
        <h1 style={{ alignSelf: "center" }}>Funders</h1>
      </div>
      <div
        style={{
          margin: "auto",
          display: "flex",
          flexWrap: "wrap",
          backgroundColor: "#242526",
          justifyContent: "space-evenly",
        }}
      >

       <div
         onMouseEnter={() => setIsShown(true)}
         onMouseLeave={() => setIsShown(false)}
       >
         {isShown === false && (
          <Image src={funder1} className="funderLogo"
                 onClick={() => {
                   window.open("https://www.fondation-roger-de-spoelberch.ch/en/")
                 }}

          /> )}

         {isShown === true && (
           <Image src={funder1} className="funderLogoHover" style={{opacity: "50%"}}
                  onClick={() => {
                    window.open("https://www.fondation-roger-de-spoelberch.ch/en/")
                  }}

           /> )}
       </div>
        <div
          onMouseEnter={() => setIsShown2(true)}
          onMouseLeave={() => setIsShown2(false)}
        >
          {isShown2 === false && (
          <Image src={funder2} className="funderLogo"
                 onClick={() => {
                   window.open("https://www.ninds.nih.gov/")
                 }}
          /> )}


          {isShown2 === true && (
            <Image src={funder2} className="funderLogoHover" style={{opacity: "50%"}}
                   onClick={() => {
                     window.open("https://www.ninds.nih.gov/")
                   }}
            /> )}

        </div>
        <div
          onMouseEnter={() => setIsShown3(true)}
          onMouseLeave={() => setIsShown3(false)}
        >
          {isShown3 === false && (
          <Image src={funder3} className="funderLogo"
                 onClick={() => {
                   window.open("https://nomisfoundation.ch/")
                 }}

          />)}
          {isShown3 === true && (
            <Image src={funder3} className="funderLogoHover" style={{opacity: "50%"}}
                   onClick={() => {
                     window.open("https://nomisfoundation.ch/")
                   }}

            />)}
        </div>


        <div
          onMouseEnter={() => setIsShown4(true)}
          onMouseLeave={() => setIsShown4(false)}
        >
          {isShown4 === false && (
          <Image src={funder4}
                 onClick={() => {
                   window.open("https://braininitiative.nih.gov/")
                 }}
                 className="funderLogo"
          />)}

          {isShown4 === true && (
            <Image src={funder4}
                   onClick={() => {
                     window.open("https://braininitiative.nih.gov/")
                   }}
                   className="funderLogoHover" style={{opacity: "50%"}}
            />)}

        </div>

      </div>

    </>
  )
}

